import { render } from "./FooterLinks.vue?vue&type=template&id=6d855638&ts=true"
import script from "./FooterLinks.vue?vue&type=script&lang=ts"
export * from "./FooterLinks.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Layouts/FooterLinks.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6d855638"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6d855638', __exports__)) {
    api.reload('6d855638', __exports__)
  }
  
  module.hot.accept("./FooterLinks.vue?vue&type=template&id=6d855638&ts=true", () => {
    api.rerender('6d855638', render)
  })

}


export default __exports__